import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTheme } from '../hooks/useTheme';
import Header from '../components/landing/Header';
import Footer from '../components/landing/Footer';
import { Card } from 'primereact/card';
import { Panel } from 'primereact/panel';
import { Divider } from 'primereact/divider';

const EliminarDatosPage = () => {
    const { theme, toggleTheme } = useTheme();

    const siteUrl = process.env.REACT_APP_SITE_URL || '';

    return (
        <div className={`landing-page theme-${theme}`}>
            <Helmet>
                <title>Eliminación de Datos – Laptops.pe</title>
                <meta name="description" content="Instrucciones oficiales para solicitar la eliminación de datos de usuario en Laptops.pe conforme a la Ley N° 29733." />
                <link rel="canonical" href={`${siteUrl}/eliminar-datos`} />
            </Helmet>

            <Header theme={theme} onToggleTheme={toggleTheme} />

            <main className="landing-main">
                <div className="py-6">
                    <div className="text-center mb-5">
                        <h1 className="text-4xl lg:text-5xl font-bold text-primary mb-2">
                            🗑️ Eliminación de Datos de Usuario
                        </h1>
                        <p className="text-700">Última actualización: <strong>Octubre 2025</strong></p>
                    </div>

                    <Card className="mb-4">
                        <div className="p-4">
                            <p className="text-700 line-height-3">
                                En <strong>Laptops.pe</strong>, operada por <strong>Digital Wins</strong>, respetamos tus derechos de
                                <em>Acceso, Rectificación, Cancelación y Oposición (ARCO)</em> según la <strong>Ley de Protección de Datos Personales N° 29733</strong>.
                                Aquí te indicamos cómo solicitar la <strong>eliminación</strong> de tus datos personales registrados en nuestros sistemas.
                            </p>
                        </div>
                    </Card>

                    <Panel header="¿Qué datos puedo solicitar eliminar?" className="mb-4">
                        <ul className="list-disc ml-4 text-700">
                            <li>Datos de cuenta: nombre, correo, teléfono y dirección.</li>
                            <li>Historial de navegación asociado a tu cuenta.</li>
                            <li>Preferencias y suscripciones a comunicaciones.</li>
                            <li>Datos de autenticación social (Google/Facebook) almacenados por Laptops.pe.</li>
                        </ul>
                        <p className="text-700 mt-3">Información contable y fiscal vinculada a compras podría conservarse por obligación legal (SUNAT y normativa vigente).</p>
                    </Panel>

                    <Panel header="¿Cómo solicitar la eliminación de mis datos?" className="mb-4">
                        <ol className="list-decimal ml-4 text-700">
                            <li>Envía un correo a <a href="mailto:soporte@laptops.pe">soporte@laptops.pe</a> con el asunto: <strong>Solicitud de eliminación de datos</strong>.</li>
                            <li>Incluye tu <strong>nombre completo</strong>, <strong>documento de identidad</strong> (DNI/RUC) y el <strong>correo</strong> asociado a tu cuenta.</li>
                            <li>Indica si tu acceso fue mediante <strong>Google</strong> o <strong>Facebook</strong> (si aplica).</li>
                            <li>Describe brevemente qué información deseas eliminar. Si es toda tu cuenta, indícalo expresamente.</li>
                        </ol>
                        <p className="text-700 mt-3">Te responderemos dentro del <strong>plazo legal</strong> y te notificaremos cuando la eliminación haya sido completada.</p>
                    </Panel>

                    <Panel header="Eliminación vinculada a Facebook Login" className="mb-4">
                        <p className="text-700">Si te autenticastes con Facebook:</p>
                        <ul className="list-disc ml-4 text-700">
                            <li>Revoca el acceso desde tu cuenta de Facebook: <strong>Configuración y privacidad → Configuración → Apps y sitios web</strong>, busca <em>Laptops.pe</em> y presiona <strong>Eliminar</strong>.</li>
                            <li>Opcionalmente, nuestro backend procesa la desautorización en: <code>https://apilw.laptops.pe/api/auth/facebook/deauthorize</code>.</li>
                        </ul>
                        <p className="text-700 mt-2">Tras la revocación, puedes solicitar por correo la eliminación de los datos asociados en nuestros sistemas.</p>
                    </Panel>

                    <Panel header="Identidad, plazos y confirmación" className="mb-4">
                        <ul className="list-disc ml-4 text-700">
                            <li>Podríamos solicitar verificación de identidad para proteger tu información.</li>
                            <li>El tiempo de atención estándar es de <strong>hasta 15 días hábiles</strong>.</li>
                            <li>Recibirás una <strong>confirmación por correo</strong> cuando la eliminación se complete.</li>
                        </ul>
                    </Panel>

                    <Divider />
                    <div className="text-center">
                        <p className="text-700">Consulta nuestra <a href="/privacidad" className="text-primary font-semibold">Política de Privacidad</a> para más detalles.</p>
                    </div>
                </div>
            </main>

            <Footer />
        </div>
    );
};

export default EliminarDatosPage;